import SvgRender from 'common/components/general/SvgRender';
import bulletIcon from 'common/assets/svg/common/location-solid.svg';
import locationtIcon from 'assets/svg/components/map/location.svg';

const Port = ({ port, icon = 'location', view }) => {
  return (
    <div className="d-flex flex-column align-items-center">
      <div className="d-flex justify-content-between">
        {port.icons.map((icon, i) => (
          <SvgRender
            key={i.toString()}
            src={icon}
            style={{ width: 20, height: 20, marginLeft: 2, marginRight: 2 }}
          />
        ))}
      </div>
      <SvgRender
        className={view === 'satellite' ? 'text-red' : 'text-primary'}
        src={icon === 'location' ? locationtIcon : bulletIcon}
        style={{ width: 18, height: 18, marginTop: 2 }}
      />
    </div>
  );
};

export default Port;
